import { config } from 'config';

export function getPhotos({ id, images = [] }) {
  return images
    .map((obj, index) => `${config.api}/view/${id}/image/${index}`);
}
